export default "__VITE_ASSET__c2ddfb0a__"